<template>
  <div :class="getClassName('sizes')">
    <ul :class="getClassName('sizes__items')" v-if="item.sizes.length > 0">
      <li :class="getClassName('sizes__item')" v-for="size in item.sizes" :key="size.id">
        <label
          :class="[
            ...getClassNameActive('sizes__action', size, value.item_size_id),
            isDisabled(size.id) ? 'sizes__action--disabled' : null,
          ]"
          :for="`${uuid}-${size.id}`"
        >
          <div :class="getClassName('sizes__name')">
            {{ size.name }}<br />
            {{ getSizePrice(size.id) }}円（税込）
            <div :class="getClassName('sizes__stock')">
              {{ getStock(size.id) }}
            </div>
          </div>
          <input
            type="radio"
            :id="`${uuid}-${size.id}`"
            :value="size.id"
            :disabled="isDisabled(size.id)"
            v-model="internalValue"
            v-show="false"
          />
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

import { numberFormat } from '../../../_modules/util';

import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    const uuid = uuidv4();
    return {
      uuid: uuid,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value.item_size_id;
      },
      set(newValue) {
        if (this.value.item_size_id === newValue) return;

        const option = this.getOption(newValue);
        this.$emit('input', { ...this.value, item_size_id: newValue, item_option_id: option.id });
      },
    },
    getSizePrice() {
      return (sizeId) => {
        const option = this.getOption(sizeId);
        return numberFormat(option.price);
      };
    },
    isDisabled() {
      return (sizeId) => {
        const option = this.getOption(sizeId);
        return option.stock === 3;
      };
    },
    getStock() {
      return (sizeId) => {
        const option = this.getOption(sizeId);
        return (
          option.stock_text +
          (this.isDisabled(sizeId) && option.arrive ? ' ' + option.arrive : '')
        );
      };
    },
  },
  watch: {
    // カラーが変更された場合はサイズをリセット
    'value.item_color_id': function (newValue) {
      // サイズが選択されている場合は何もしない
      // 元がnullの場合もイベントを発火（null:在庫なしなど）
      if (this.value.item_size_id !== null && !this.isDisabled(this.value.item_size_id)) return;

      const size_ids = this.item.sizes.filter((size) => !this.isDisabled(size.id));
      // 在庫があるサイズが1つ以上ある場合は最初のサイズを選択
      if (size_ids.length === 0) {
        this.$emit('input', { ...this.value, item_size_id: null, item_option_id: null });
      } else {
        const [size] = size_ids;
        const option = this.getOption(size.id);
        this.$emit('input', { ...this.value, item_size_id: size.id, item_option_id: option.id });
      }
    },
  },
  methods: {
    getOption(sizeId) {
      const [option] = this.item.options.filter(
        (option) =>
          option.item_color_id === parseInt(this.value.item_color_id) &&
          option.item_size_id === parseInt(sizeId)
      );
      return option;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';

.sizes {
  &__items {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: repeat(2, 1fr);
    &--sp {
      display: block;
    }
  }
  &__item {
    &:nth-child(2n + 1) {
      border-right: solid 1px #e8e8e8;
      &:not(:nth-child(-n + 2)) {
        border-top: solid 1px #e8e8e8;
      }
    }
    &:nth-child(2n + 0) {
      transform: translate(0, 1px);
      &:not(:last-child) {
        border-bottom: solid 1px #e8e8e8;
      }
    }
    &--sp {
      border: none !important;
      &:not(:first-child) {
        margin-top: 10px;
      }
      &:nth-child(2n + 0) {
        transform: none;
      }
    }
  }
  &__action {
    width: 100%;
    height: 100%;
    padding: 39px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    &::before {
      content: '';
      background: url(../images/check.svg) no-repeat center center;
      background-color: #fff;
      background-size: 13px 10px;
      width: 26px;
      height: 26px;
      border: solid 1px #d0d0d0;
      box-sizing: border-box;
      border-radius: 50%;
      margin-right: 15px;
      flex: 0 0 auto;
      transition: all 0.2s ease 0s;
    }
    &--active::before {
      background-color: $color__active;
      border-color: $color__active;
    }
    &--disabled {
      cursor: auto;
      &::before {
        border: solid 1px transparent;
      }
    }
    &--sp {
      padding: 9px 0;
      border: solid 1px $color__line--item;
      text-align: center;
      display: block;
      transition: all 0.2s ease 0s;
      &::before {
        content: none;
      }
      &.sizes__action--active {
        box-shadow: 0px 0px 0px 3px $color__active;
      }
    }
  }
  &__name {
    &--sp {
      font-size: 1rem;
    }
  }
  &__stock {
    margin-top: 5px;
    font-size: 1.1rem;
    &--sp {
      margin-top: 0;
      font-size: 1rem;
    }
  }
}
</style>
